module.exports = __webpack_public_path__ + "static/media/student7.55400b42.svg";